import { OnInit, Inject, Component} from '@angular/core';
import { Globals } from '../../globals'
import { MenuItem } from 'primeng/api';
import { SelectItem } from 'primeng/api';
import { Message } from 'primeng/primeng';
import { ILookupBase } from 'src/app/Models/ILookupBase';
import { LookupService } from 'src/app/Services/LookupService';
import { LookupTypeEnum } from 'src/app/Models/Enums/LookupTypeEnum';
import { IActivityLog } from 'src/app/Models/IActivityLog';
import { ActivityLogService } from 'src/app/Services/ActivityLogService';
import { IReportParameter } from 'src/app/Models/IReportParameter';
import { ReportService } from 'src/app/Services/ReportService';
import { SpinnerBase } from 'src/app/Components/Base/SpinnerBase';

@Component({
  selector: 'activitylog',
  templateUrl: './ActivityLog.component.html',
  styleUrls: ['./ActivityLog.component.css']
})
export class ActivityLogComponent extends SpinnerBase {
  _myGlobals: Globals;
  date: Date; //datepicker
  maxDate: Date;
  messages: Message[];
  selectedActivityType: SelectItem; //dropdown
  _selectedActivityType: string = 'Select....';
  activityTypeList: ILookupBase[] = [];
  _lookupService: LookupService;
  _baseUrl: string;
  comment: string = "";
  comments = new Map<number, string>();
  cols: any[];
  _activityLogService: ActivityLogService;
  selectedActivityLog: IActivityLog = null;
  canSaveSelectedActivityLog: boolean = false;
  expandCheckboxValue: boolean;
  _expanded: boolean = false;
  rowSelected: boolean = false;
  reportParamArray: IReportParameter[];
  stdSerMenuItems: MenuItem[];
  stdSerMenuItemsDisabled: MenuItem[];
  listLookupCommentTypes: ILookupBase[];
  selectedLookupCommentType: ILookupBase;
  currentLookupCommentTypeId: string = '0';

  constructor(
    lookupService: LookupService,
    @Inject('BASE_URL') baseUrl: string,
    private globals: Globals,
    reportService: ReportService,
    activityLogService: ActivityLogService) {
    super(reportService);
    this._myGlobals = globals;
    this._lookupService = lookupService;
    this._baseUrl = baseUrl;
    this._activityLogService = activityLogService;
    this.stdSerMenuItems = [
      { label: 'Student Search', command: (event: Event) => { this._myGlobals.selectedIepMenuItem(0); this._myGlobals.stdSerSelected = '' } }
    ];
    this.stdSerMenuItemsDisabled = [
      { label: 'Student Search', command: (event: Event) => { this._myGlobals.selectedIepMenuItem(0); this._myGlobals.stdSerSelected = '' }, disabled: true }
    ];

    this.cols = [
      { field: 'creatorUserName', header: 'Created By' },
      { field: 'createdDateStr', header: 'Date Created' },
      { field: 'activityLogType', header: 'Type' },
      { field: 'activityDateStr', header: 'Activity Date' },
      { field: 'comment', header: 'Comment' }
    ];
  }
  totalRecords: number;

  ngOnInit() {
    this._myGlobals.editMode = false;
    this.selectedLookupCommentType = { value: '0', label: '', shortText: '', updatedOn: null };
    this.currentLookupCommentTypeId = '';
    this.expandCheckboxValue = false;
    let today = new Date();
    this.date = new Date(today.getMonth() + 1 + '/' + today.getDate() + '/' + today.getFullYear());
    this.maxDate = new Date(today.getMonth() + 1 + '/' + today.getDate() + '/' + today.getFullYear());
    this.LoadLookupValues();
    this.LoadActivityLog(false);
    this.totalRecords = this._myGlobals.activityLogs.length;
  } 

  LoadLookupValues() {
    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.ActivityLog]).subscribe((res: any[]) => {
      this.listLookupCommentTypes = [] as ILookupBase[];
      this.listLookupCommentTypes.push({ label: 'View All or Select a Filter', value: '0', shortText: 'View All or Select a Filter', updatedOn: null });
      this.listLookupCommentTypes.push.apply(this.listLookupCommentTypes, res);

      this.activityTypeList = [{ value: null, label: "Select...", shortText: null, updatedOn: null }].concat(res);
    },
      err => console.error(err)
    );
  }

  LoadActivityLog(expanded: boolean): void {
    // this prevents API calls if no change has occurred, or, values are null/undefined
    if (this._myGlobals == null ||
      this._myGlobals == undefined ||
      this._myGlobals.selectedStudent == null ||
      this._myGlobals.selectedStudent == undefined ||
      this.selectedLookupCommentType == undefined) {
              return;
    }

    this.selectedActivityLog = null;

    if (this.selectedLookupCommentType.value == undefined) {
      this.currentLookupCommentTypeId = this.selectedLookupCommentType.toString();  
    }
    else {
      this.currentLookupCommentTypeId = this.selectedLookupCommentType.value;  
    }
    
    this._activityLogService.getAllActivityLogForStudent(this._myGlobals.selectedStudent.localStudentId + '^' + this.currentLookupCommentTypeId)
      .subscribe((res: IActivityLog[]) => {     
        this._myGlobals.activityLogs = res;
        this._myGlobals.activityLogs.forEach((log, index, logs) => {
          log.activityDate = log.activityDate == null ? null : new Date(log.activityDate)
          log.activityDateStr = new Date(log.activityDate).toISOString().slice(0, 10);
          let createdDate: Date = new Date(log.createdDate);
          let utc = new Date(Date.UTC(createdDate.getFullYear(), createdDate.getMonth(), createdDate.getDate(), createdDate.getHours(), createdDate.getMinutes()))//treat date as utc instead of local
          log.createdDateStr = new Date(utc).toISOString().slice(0, 10);
          if (!expanded) {
            log.comment = log.comment.substr(0, 20).concat(' ...');
          }
          else {
            log.comment = log.comment;
          }
        });
      },
        err => console.error(err)
      );
  }

  onRowSelect(event) {
    this.clearMessages();
    let tempSelectedActivityLog = event.data as IActivityLog;

    this._activityLogService.getActivityLog(tempSelectedActivityLog.id.toString()).subscribe((res: IActivityLog) => {
      this.selectedActivityLog = res;
      this.selectedActivityLog.activityLogLookupId = this.selectedActivityLog.activityLogLookupId.toString();
      this.selectedActivityLog.activityDate = this.selectedActivityLog.activityDate != null ? new Date(this.selectedActivityLog.activityDate) : null;
      this.canSaveSelectedActivityLog = !(
        this._myGlobals.canUserEditAllActivityLogs === false
        && this.selectedActivityLog && this.selectedActivityLog.id > 0
        && this.selectedActivityLog.creatorUserName.toUpperCase() !== this._myGlobals.spedSecurityUsername.toUpperCase()
      );
      if (this.canSaveSelectedActivityLog === false) {
        let warningMessage: Message = { severity: 'warn', summary: 'Cannot edit activity logs created by another user' };
        this.addMessage(warningMessage);
      }
      this._myGlobals.editMode = true;
      },
        err => console.error(err)
      );
  }

  onRowUnselect(event) {
    this.selectedActivityLog = null;
  }
  
  setActivityType(id) {
    this._selectedActivityType = id.value;
  }

  expandComments(value) {
    this._expanded = value;
    this.LoadActivityLog(this._expanded);    
  }

  commentTypeFilterSelection() {
    this.LoadActivityLog(this._expanded);
  }

  Add(): void {
    this.canSaveSelectedActivityLog = true;
    this._myGlobals.editMode = true;
    this.selectedActivityLog = {} as IActivityLog;
  }

  Save(): void {
    this.clearMessages();

    if (
      this.selectedActivityLog.activityLogLookupId == null || this.selectedActivityLog.activityLogLookupId == undefined) {
      let warningMessage: Message = { severity: 'warn', summary: 'Please select an Activity Type!' };
      this.addMessage(warningMessage);
    }
    if (
      this.selectedActivityLog.activityDate == null || this.selectedActivityLog.activityDate == undefined) {
      let warningMessage: Message = { severity: 'warn', summary: 'Please select a date!' };
      this.addMessage(warningMessage);
    }
    if (
      this.selectedActivityLog.comment == null || this.selectedActivityLog.comment == undefined || this.selectedActivityLog.comment == '') {
      let warningMessage: Message = { severity: 'warn', summary: 'Please enter a comment!' };
      this.addMessage(warningMessage);
    }
    else if (
      this.selectedActivityLog.comment.length<5) {
      let warningMessage: Message = { severity: 'warn', summary: 'Please enter a comment least 5 characters!' };
        this.addMessage(warningMessage);
    }

    if (this.messages == null || this.messages.length == 0){
      this.showSpinner = true;
      this.selectedActivityLog.localStudentId = this._myGlobals.selectedStudent.localStudentId;
      this.selectedActivityLog.iepId = null;
      this.selectedActivityLog.administrativePlacementId = null;	
      this._activityLogService.insertUpdateActivityLog(this.selectedActivityLog)
        .subscribe((res: IActivityLog) => {
          this.timeStamp = new Date();
          let successMessage: Message = { severity: 'success', summary: 'Record Saved Successfully.  Record Id: ', detail: res.id.toString() + ' at: ' + this.timeStamp.toLocaleTimeString() }
          this.addMessage(successMessage);
          this._myGlobals.editMode = false;
          this.showSpinner = false;
          this.selectedActivityLog = null;
          this.LoadActivityLog(this._expanded);
        },
          (error) => {
            let errorMessage: Message = { severity: 'error', summary: 'Save Failed', detail: error };
            this.addMessage(errorMessage);
            this.showSpinner = false;
          }
      );      
    }
  }

  Print(): void {
    var x = this._myGlobals.selectedStudent.localStudentId;
    if (this._myGlobals.selectedStudent.localStudentId === undefined ||
      this._myGlobals.selectedStudent.localStudentId === null) { new alert('Student not selected!'); return }
    this.populateReportParameters();
    document.getElementById("printBtn").setAttribute('disabled', 'true');
    this.controlPrintSpinner(true);
    this._myGlobals.printNonFormCommon(" SpedXReports ", "IEP_ActivityLog", this.reportParamArray);
    this.controlPrintSpinner(false);
    document.getElementById("printBtn").removeAttribute('disabled');
  }

  controlPrintSpinner(showSpinner: boolean) {
    this.showSpinner = showSpinner;
  }

  populateReportParameters() {
    this.reportParamArray = [];
    this.reportParamArray.push(
      { parameterName: 'StudentID', parameterValue: this._myGlobals.selectedStudent.localStudentId },
      { parameterName: 'ShowCustomWaterMark', parameterValue: 'False' },
      { parameterName: 'CustomWatermarkText', parameterValue: '' },
      { parameterName: 'Types', parameterValue: '1#2#3#8#9#12#13#16#17#20#24' }      
    );
  }

  addMessage(msg: Message) {
    if (!this.messages)
      this.messages = [];
    this.messages = [...this.messages, msg];
  }

  clearMessages() {
    this.messages = [];
  }

  Cancel(): void {
    this.clearMessages();
    this._myGlobals.editMode = false;
    this.LoadActivityLog(this._expanded);
  }
}
